import DeprecatedDropdownContainer from 'components/Luxkit/Dropdown/DeprecatedDropdownContainer'
import React from 'react'
import OfferCalendarRoomOptions from './OfferCalendarRoomOptions'

interface Props {
  onClose?: () => void;
}

function OfferCalendarRoomDropdown(props: Props) {
  const { onClose } = props

  return (
    <DeprecatedDropdownContainer
      title="Rooms"
      onClose={onClose}
      fit="dropdown-items"
    >
      <OfferCalendarRoomOptions onSelect={onClose} />
    </DeprecatedDropdownContainer>
  )
}

export default OfferCalendarRoomDropdown
